/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIPosition
 */
export interface APIPosition {
    /**
     * 
     * @type {string}
     * @memberof APIPosition
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPosition
     */
    name?: string;
}

/**
 * Check if a given object implements the APIPosition interface.
 */
export function instanceOfAPIPosition(value: object): value is APIPosition {
    return true;
}

export function APIPositionFromJSON(json: any): APIPosition {
    return APIPositionFromJSONTyped(json, false);
}

export function APIPositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPosition {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function APIPositionToJSON(value?: APIPosition | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

